<script>
import TransparentButton from "./TransparentButton.vue";

export default {
    name: 'FormPasswordBox',

    components: {TransparentButton},

    props: {
        inputValue: String,

        label: String,

        labelPosition: {
            type: String,
            default: 'left',
        },

        prop: String,

        required: {
            type: Boolean,
            default: false,
        },

        // large, default, small
        size: {
            type: String,
            required: false,
        },

        customClass: {
            type: String,
            default: '',
            required: false,
        },

        placeholder: {
            type: String,
            default: '',
            required: false,
        },

        clearable: {
            type: Boolean,
            default: false,
            required: false,
        },

        showPassword: {
            type: Boolean,
            default: false,
            required: false,
        },

        disabled: {
            type: Boolean,
            default: false,
            required: false,
        },

        maxLength: {
            type: Number,
            default: null,
        }
    },

    data() {
        return {
            togglePasswordShow: false,
        }
    },

    methods: {
        onInput(value) {
            // 親へ値を返す（Vue2では :inputValue と @update:inputValue を推奨）
            this.$emit('update:inputValue', value)
        },

        toggleShowPasswordTextType() {
            this.togglePasswordShow = !this.togglePasswordShow;
        },
    },
}
</script>

<template>
    <form>
        <el-form-item :label="label" :label-position="labelPosition" :prop="prop">
            <!-- Vue2 の slot 構文 -->
            <template v-if="label" slot="label">
                {{ label }}
                <span class="asterisk" v-if="required">＊</span>
            </template>

            <el-input
                :value="inputValue"
                :type="togglePasswordShow ? 'text' : 'password'"
                @input="onInput"
                :size="size"
                :class="customClass"
                :placeholder="placeholder"
                :clearable="clearable"
                :disabled="disabled"
                :maxlength="maxLength"
            >
                <template slot="prefix">
                    <slot name="prefix"/>
                </template>
                <template slot="suffix">
                    <slot name="suffix"/>
                    <TransparentButton
                        v-if="showPassword"
                        iconSrc=""
                        :label="togglePasswordShow ? 'HIDE' : 'SHOW'"
                        :disabled="false"
                        class="showHideText"
                        @click="toggleShowPasswordTextType"
                    />
                </template>
            </el-input>
        </el-form-item>
    </form>
</template>

<style scoped>

.asterisk {
    margin: 0 5px;
    color: red;
}

.showHideText :deep(.buttonText) {
    padding: 0;
    font-size: 10px;
    color: #848991;
}

/* suffix全体を縦中央揃え */
:deep(.el-input__suffix) {
    display: flex;
    align-items: center;
}

/* Element UI の必須 * を消す */
::v-deep(.el-form-item__label)::before {
    display: none;
}

</style>
